import { ChargebacksDetailsTabs } from "globalConstants";
import { hasPermissions, permissionList } from "helpers";

export const chargebacksDetailsTabs = [
	{
		path: ChargebacksDetailsTabs.MerchantInformation.name,
		name: ChargebacksDetailsTabs.MerchantInformation.displayName,
		requiredPermissions: permissionList.PeriodicCreditReview,
	},
	{
		path: ChargebacksDetailsTabs.ChargebacksReview.name,
		name: ChargebacksDetailsTabs.ChargebacksReview.displayName,
		requiredPermissions: permissionList.PeriodicCreditReview,
	},
	{
		path: ChargebacksDetailsTabs.Notes.name,
		name: ChargebacksDetailsTabs.Notes.displayName,
		requiredPermissions: permissionList.ViewAccountNotes,
	},
	{
		path: ChargebacksDetailsTabs.Attachments.name,
		name: ChargebacksDetailsTabs.Attachments.displayName,
		requiredPermissions: permissionList.PeriodicCreditReview,
	},
];

export const getChargebacksDetailsTabsPaths = () =>
	chargebacksDetailsTabs
		.filter(tab => hasPermissions(tab?.requiredPermissions))
		.map(tab => tab.path);
